// extracted by mini-css-extract-plugin
export default {"grid":"LoadChartTooltip_grid__kpjmL","timestamp":"LoadChartTooltip_timestamp__Z25vJ","amperage":"LoadChartTooltip_amperage__i81Js"};